﻿(function (angular) {
  "use strict";

  angular.module("Toyota").directive("tyLinkDisabled", [
    "ToastManager",
    function (ToastManager) {
      return {
        scope: true,
        restrict: "A",
        link: function (scope, element, attrs) {
          var TOAST_GROUP = "disabledLink";
          if (attrs.tyLinkDisabledToastText) {
            element.on("click", function () {
              ToastManager.removeToastsByGroup(TOAST_GROUP);
              ToastManager.triggerBriefToast(attrs.tyLinkDisabledToastText, TOAST_GROUP);
              element.blur();
            });
          }
        },
      };
    },
  ]);
})(window.angular);
